// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CBvj","controls":"styles_controls__1J6Ng","charLimit":"styles_charLimit__3SiS9","input":"styles_input__fTtv_","send":"styles_send__bjyUs"};